module.exports = __webpack_public_path__ + "img/invite_coupon.f68bd5f6.png";